import { gql } from '@apollo/client'
import classNames from 'classnames'
import { Children, cloneElement, isValidElement, ReactNode } from 'react'

import printStyles from '../../print.module.scss'
import {
  DocPrintable_DocumentFragment,
  DocPrintable_ViewerFragment,
} from './__generated__/doc-printable.graphql'
import styles from './doc-printable.module.scss'

export interface DocPrintableProps {
  children: ReactNode
  canCopy: boolean
  document: DocPrintable_DocumentFragment
  viewer: DocPrintable_ViewerFragment | null
}

export function DocPrintable(props: DocPrintableProps) {
  const { children, canCopy, viewer, document } = props

  const hasPendingPayment = !!viewer?.subscriptions?.some((s) => s?.overdue)
  const preventPrint = !canCopy || hasPendingPayment

  const currentDate = new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'long',
  }).format(new Date())

  return (
    <>
      <div className={styles.print}>
        <p className={styles.printTitle}>jusbrasil.com.br</p>
        <p className={styles.printDate}>{currentDate}</p>
        <p className={styles.printUrl}>
          {viewer && !preventPrint && (
            <>
              Disponível em: <span>{document.url}</span>
            </>
          )}
          {viewer && preventPrint && (
            <>
              Torne-se PRO e imprima conteúdo ilimitado do Jusbrasil.
              <span>
                Aproveite ainda mais do Jusbrasil com recursos especiais e ilimitados. Acesse:
                <br />
                https://www.jusbrasil.com.br/pro
              </span>
            </>
          )}
          {!viewer && (
            <>
              Entre no Jusbrasil para imprimir o conteúdo. Acesse:
              <span>https://www.jusbrasil.com.br/cadastro</span>
            </>
          )}
        </p>
      </div>

      {preventPrint && isValidElement<{ className?: string }>(children)
        ? cloneElement(Children.only(children), {
            className: classNames(children.props.className, printStyles.unprintable),
          })
        : children}
    </>
  )
}

DocPrintable.fragments = {
  document: gql`
    fragment DocPrintable_document on Document {
      url
    }
  `,
  viewer: gql`
    fragment DocPrintable_viewer on Profile {
      pid
      subscriptions {
        overdue
      }
    }
  `,
}
